module.exports = __webpack_public_path__ + "ov_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_1.jpg
// module id = 869
// module chunks = 0